import { defineStore } from 'pinia';

export interface SSOStateInterface { // 页面状态
  modal: any; // 对话框
}

/**
 * 页面数据
 */
export default defineStore('sso', {
  state: (): SSOStateInterface => { // 状态
    return {
      modal: {}
    };
  },
  getters: { // 获取
  },
  actions: { // 方法
    //----- 对话框 Start -----//
    /**
     * 更新对话框
     * @param {*} data 数据
     */
    updateModal(data: any): void {
      this.modal = data;
    },
    
    /**
     * 开启对话框
     * @param {string} name 名称
     * @param {any} data 数据
     */
    openModal(name: string, data: any = null): void {
      this.modal[name]?.[0]?.open(data);
    },
    
    /**
     * 关闭对话框
     * @param {string} name 名称
     */
    closeModal(name: string): void {
      this.modal[name]?.[0]?.close();
    }
    //----- 对话框 End -----//
  }
});